import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { take } from 'rxjs/operators';
import { AuthorizeService, IUser } from 'src/api-authorization/authorize.service';
import { Player } from 'src/models/player.model';
import { UserService } from '../../services/user.service';
import { UserSettings } from '../../models/player.model';


@Component({
  selector: 'tournament',
  templateUrl: './tournament.component.html',
  styleUrls: ['./tournament.component.scss']
})
export class TournamentComponent implements OnInit {
  public busy: boolean;
  public tournamentBracket = {};
  public faTrophy = faTrophy;
  public showRecord: boolean = false;
  public queryFailed: boolean = false;
  public retryCount: number = 0;

  constructor(private http: HttpClient, private authorizeSvc: AuthorizeService,
    private route: ActivatedRoute,
    private router: Router, private userSvc: UserService) {
    this.busy = true;
  }

  public ngOnInit() {
    this.busy = true;
    this.http.get<any>('/api/tournament').subscribe(
      (resp) => {
        const tournamentPlayers = resp.round8.map(r => r.player.id).filter(r => !r.startsWith('00000000-0000'));

        // turn on/off record button
        this.authorizeSvc.getUser().pipe(take(1)).subscribe((u) => {
          this.showRecord = (tournamentPlayers.includes(u.sub) || u.sub == 'acfc2497-cb44-4394-b866-3f546b306ff6')
            && resp.round1[0].score == null
        });

        this.tournamentBracket['round8'] = [];
        for (const n of resp.round8) {
          if (n.player)
            this.tournamentBracket['round8'].push({ player: new Player(n.player), score: n.score });
          else
            this.tournamentBracket['round8'].push({});
        }
        this.tournamentBracket['round4'] = [];
        for (const n of resp.round4) {
          if (n.player)
            this.tournamentBracket['round4'].push({ player: new Player(n.player), score: n.score });
          else
            this.tournamentBracket['round4'].push({});
        }
        this.tournamentBracket['round2'] = [];
        for (const n of resp.round2) {
          if (n.player)
            this.tournamentBracket['round2'].push({ player: new Player(n.player), score: n.score });
          else
            this.tournamentBracket['round2'].push({});
        }
        this.tournamentBracket['round1'] = [];
        for (const n of resp.round1) {
          if (n.player)
            this.tournamentBracket['round1'].push({ player: new Player(n.player), score: n.score });
          else
            this.tournamentBracket['round1'].push({});
        }
        this.busy = false;
      },
      (err) => { 
        this.busy = false;
        const queryParamMap = this.route.snapshot.queryParamMap; // avoid infinite loop   1
        // first avoid infinite loop
        if(parseInt(queryParamMap.get('retry')||'', 10) > 0 ) {
          this.queryFailed = true;
          return;
        }
        else this.retryCount++;

        // next, get this players ladders and levels. see if they were in a level in this ladder
        const ladderId = this.route.snapshot.paramMap.get('ladderId') || '';
        this.userSvc.getLaddersAndLevels().subscribe(
          (resp: UserSettings[]) => {
            const validOne = resp.find(r => r.ladderId == ladderId && r.levelId > 1);
            if( validOne ) {
              debugger;
              this.userSvc.clearCache();
              localStorage.setItem('ladderId', validOne.ladderId);
              localStorage.setItem('levelId', validOne.levelId.toString());
              this.router.navigate(['/tournament', ladderId], {queryParams: { retry: this.retryCount++ }});
            }
            else {
              // finally, check if they were a viewer and kick them to all tournaments
              const validOne = resp.find(r => r.ladderId == ladderId );
              if(validOne) {
                this.userSvc.clearCache();
                localStorage.setItem('ladderId', validOne.ladderId);
                localStorage.setItem('levelId', '1'); // viewer
                this.router.navigate(['/alltournament'], {queryParams: { retry: this.retryCount++ }});
              }
              else {
                // if that fails, just bail and show a message..... ? why are they even here?
                this.queryFailed = true;
              }
            }
          }
        );
    
      }
    )
  }
}

  // public tournamentBracket = {
  //   round8: [
  //     { player: new Player({ id: 'p1', lastName: '', firstName: 'Group A #1' }) },
  //     { player: new Player({ id: 'p8', lastName: '', firstName: 'Group B #4' }) },
  //     { player: new Player({ id: 'p5', lastName: '', firstName: 'Group A #3' }) },
  //     { player: new Player({ id: 'p4', lastName: '', firstName: 'Group B #2' }) },
  //     { player: new Player({ id: 'p3', lastName: '', firstName: 'Group A #2' }) },
  //     { player: new Player({ id: 'p6', lastName: '', firstName: 'Group B #3' }) },
  //     { player: new Player({ id: 'p7', lastName: '', firstName: 'Group A #4' }) },
  //     { player: new Player({ id: 'p2', lastName: '', firstName: 'Group B #1' }) }
  //   ],
  //   round4: [
  //     {},
  //     {},
  //     {},
  //     {},
  //   ],
  //   round2: [
  //     {},
  //     {},
  //   ],
  //   round1: [
  //     {},
  //   ]
  // };
  // public tournamentBracket = {
  //   round8: [
  //     { player: new Player({ id: 'p1', lastName: '', firstName: 'eric' }) },
  //     { player: new Player({ id: 'p8', lastName: '', firstName: 'tom' }) },
  //     { player: new Player({ id: 'p5', lastName: '', firstName: 'bob' }) },
  //     { player: new Player({ id: 'p4', lastName: '', firstName: 'mike' }) },
  //     { player: new Player({ id: 'p3', lastName: '', firstName: 'pete' }) },
  //     { player: new Player({ id: 'p6', lastName: '', firstName: 'chuck' }) },
  //     { player: new Player({ id: 'p7', lastName: '', firstName: 'steve' }) },
  //     { player: new Player({ id: 'p2', lastName: '', firstName: 'sam' }) }
  //   ],
  //   round4: [
  //     { player: new Player({ id: 'p1', lastName: '', firstName: 'eric' }), score: '6-1, 6-3' },
  //     { player: new Player({ id: 'p4', lastName: '', firstName: 'mike' }), score: '6-2, 6-3' },
  //     {},
  //     { player: new Player({ id: 'p2', lastName: '', firstName: 'sam' }), score: '6-3, 6-3' },
  //   ],
  //   round2: [
  //     { player: new Player({ id: 'p1', lastName: '', firstName: 'eric' }), score: '6-4, 6-3' },
  //     {},
  //   ],
  //   round1: [
  //     {},
  //   ]
  // };
